import Select from './EdgifySelect';

export default Select;
